/**
 * Pill — a tiny labelled stat chip shared across PalGame tabs
 * (Arena reward summary, Expedition reward summary, etc.).
 *
 * Extracted from ArenaTab.jsx (2026-06-14) because ExpeditionTab was
 * silently using it without ever importing or defining it — the
 * AppErrorBoundary correctly caught the resulting "Pill is not defined"
 * ReferenceError when the user opened the expedition reward screen.
 */
export function Pill({ label, value, highlight }) {
  return (
    <div
      className={
        "rounded bg-black/30 border px-3 py-2 " +
        (highlight ? "border-[var(--teal)]" : "border-white/5")
      }
    >
      <div className="text-[10px] uppercase tracking-wider text-[var(--muted)]">
        {label}
      </div>
      <div className={"text-sm font-semibold " + (highlight ? "glow-teal" : "")}>
        {value}
      </div>
    </div>
  );
}
